import { ArrowRight, Phone } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      id="cta-final"
      data-testid="final-cta-section"
      className="relative py-24 md:py-36 bg-primary text-primary-foreground overflow-hidden"
    >
      <div aria-hidden className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 h-[520px] w-[520px] rounded-full bg-white/5 blur-3xl" />
        <div className="absolute inset-x-0 bottom-0 h-px bg-white/10" />
      </div>

      <div className="container-narrow relative text-center reveal">
        <span className="text-xs font-semibold uppercase tracking-[0.24em] text-white/70">
          C'est le moment
        </span>
        <h2 className="mt-6 font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02]">
          Lancez votre projet{" "}
          <span className="italic font-light text-white/80">
            dès aujourd'hui
          </span>
          .
        </h2>
        <p className="mt-6 max-w-2xl mx-auto text-base md:text-lg text-white/70">
          Étude de sol, permis de construire, accompagnement complet : un
          seul interlocuteur pour sécuriser votre projet à La Réunion.
        </p>

        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <a
            href="#contact"
            data-testid="final-cta-devis"
            className="group inline-flex items-center gap-2 bg-[hsl(var(--brand-terra))] text-white px-8 py-5 text-sm font-medium tracking-wide rounded-full transition-all duration-300 hover:-translate-y-0.5 hover:bg-[hsl(var(--brand-terra)/0.9)]"
          >
            Demander mon devis gratuit
            <ArrowRight
              size={18}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </a>
          <a
            href="#callback"
            data-testid="final-cta-rappel"
            className="inline-flex items-center gap-2 border border-white/40 text-white px-8 py-5 text-sm font-medium tracking-wide rounded-full transition-all duration-300 hover:bg-white hover:text-primary"
          >
            <Phone size={16} strokeWidth={1.6} />
            Être rappelé
          </a>
        </div>
      </div>
    </section>
  );
}
